import React from "react";
import './team.css'
import TemCrd from "../tem-crd/tem-crd";
import Lottie from "lottie-react";
import ani2 from '../animations/ani2.json'

function Team(){
    return(
        <section className="team">
            <div className="heading">
                <h1>Our Team</h1>
            </div>
            <Lottie className="ani2" animationData={ani2}/>
            <div className="tem-cnt">


            <div className="admins">
                <TemCrd
                    Img={""}
                    Name={"Anshuman Mishra"}
                    Position={"Chair"}
                    instalink={"https://www.instagram.com/iam_anshuman_mishra?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="}
                    linkedinlink={"https://www.linkedin.com/in/anshuman-mishra-b58941299/"}
                    
                />
                                <TemCrd
                    Img={""}
                    Name={"Tejaswini Sontakke"}
                    Position={"Vice Chair "}
                    instalink={"https://www.instagram.com/tejaswini_1819/"}
                    linkedinlink={"https://www.linkedin.com/in/tejaswini-sontakke-682b86288/"}
                />
                <TemCrd
                    Img={""}
                    Name={"Aarti  Mandavgane"}
                    Position={"Secretary"}
                    instalink={"https://www.instagram.com/arati_256/"}
                    linkedinlink={"https://www.linkedin.com/in/arati-mandavgane-430b0a248/"}
                />
                                <TemCrd
                    Img={""}
                    Name={"Aniket Chaudhari"}
                    Position={"Tresurer"}
                    instalink={"https://www.instagram.com/aniketchaudhari_2002/"}
                    linkedinlink={"https://www.linkedin.com/in/aniket-chaudhari-392b06249/"}
                />
                                <TemCrd
                    Img={""}
                    Name={"Sudanshu Uttawar"}
                    Position={"Departmental Head"}
                    instalink={"https://www.instagram.com/sudhanshu__03_/"}
                    linkedinlink={"https://www.linkedin.com/in/sudhanshu-uttarwar/"}
                />
                <TemCrd
                    Img={""}
                    Name={"Atharva Khewalkar"}
                    Position={"Web Master"}
                    instalink={"https://www.instagram.com/atharvaa.14?igsh=M204YWprdXJwa3B4"}
                    linkedinlink={"https://www.linkedin.com/in/atharva-khewalkar-06a588229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"}
                />
                </div>






                               <TemCrd
                    Img={""}
                    Name={"Om Satwadhar"}
                    Position={"Joint Secretary"}
                />
                               <TemCrd
                    Img={""}
                    Name={"Suyash Jadhav"}
                    Position={"Joint Secretary"}
                />
                               <TemCrd
                    Img={""}
                    Name={"Dnyaneshwar Ambekar"}
                    Position={"E&TC Departmental Coordinator"}
                />
                               <TemCrd
                    Img={""}
                    Name={"Manik Sharma"}
                    Position={"CS Departmental Coordinator "}
                />
                               <TemCrd
                    Img={""}
                    Name={"Pushkar Brahmankar"}
                    Position={"A&R Departmental Coordinator"}
                />
                               <TemCrd
                    Img={""}
                    Name={"Sakshi Sudrik"}
                    Position={"IT Departmental Coordinator"}
                />
                               <TemCrd
                    Img={""}
                    Name={"Sarthak Pasilkar"}
                    Position={"Media Content Head "}
                />
                               <TemCrd
                    Img={""}
                    Name={"Shaikh Muzaffar"}
                    Position={"Technical Head (IT) "}
                />
                               <TemCrd
                    Img={""}
                    Name={"Jayesh Jagtap"}
                    Position={"Technical Head (Core) "}
                />
                               <TemCrd
                    Img={""}
                    Name={"Atharva Deoghare"}
                    Position={"Public Relations Head"}
                />
                               <TemCrd
                    Img={""}
                    Name={"Bhavesh Choudhary"}
                    Position={"Assistant treasurer"}
                />
                             
                               <TemCrd
                    Img={""}
                    Name={" Disha Jadhav"}
                    Position={"Assistant Media Content Head "}
                />
                               <TemCrd
                    Img={""}
                    Name={"Vaishnavi Desai"}
                    Position={"Assistant Media Content Head "}
                />
                <TemCrd
                    Img={""}
                    Name={"Anjali Jha"}
                    Position={"Assistant Technical Head "}
                />
                <TemCrd
                    Img={""}
                    Name={" Irfa Arshad"}
                    Position={"Assistant Technical Head  "}
                />
                <TemCrd
                    Img={""}
                    Name={"Sakshi Babanagare"}
                    Position={"Assistant Technical Head  "}
                />
                <TemCrd
                    Img={""}
                    Name={"Shravani Giri"}
                    Position={"Assistant Technical Head "}
                />
                <TemCrd
                    Img={""}
                    Name={"Aradhana Shukla"}
                    Position={"Assistant PR Head"}
                />
                 <TemCrd
                    Img={""}
                    Name={" Pranav Amale"}
                    Position={" Assistant PR Head "}
                />
                 <TemCrd
                    Img={""}
                    Name={" Akhilesh takale"}
                    Position={" Assistant PR Head "}
                />

            </div>
        </section>
    )
}

export default Team;